import { Injectable, signal } from '@angular/core';

export interface ToastConfig {
  message: string;
  detail?: string;
  durationSeconds?: number;
  undoLabel?: string;
  onUndo?: () => void;
}

export interface ToastState extends ToastConfig {
  id: number;
  secondsLeft: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  readonly toast = signal<ToastState | null>(null);

  private nextId = 1;
  private tickHandle: ReturnType<typeof setInterval> | null = null;

  show(config: ToastConfig): void {
    this.clearTimer();

    const duration = config.durationSeconds ?? 5;
    this.toast.set({ ...config, id: this.nextId++, secondsLeft: duration });

    this.tickHandle = setInterval(() => {
      const current = this.toast();
      if (!current) { this.clearTimer(); return; }

      if (current.secondsLeft <= 1) {
        this.dismiss();
        return;
      }
      this.toast.set({ ...current, secondsLeft: current.secondsLeft - 1 });
    }, 1000);
  }

  undo(): void {
    this.toast()?.onUndo?.();
    this.dismiss();
  }

  dismiss(): void {
    this.clearTimer();
    this.toast.set(null);
  }

  private clearTimer(): void {
    if (this.tickHandle) {
      clearInterval(this.tickHandle);
      this.tickHandle = null;
    }
  }
}
